import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Loader from '../Utility/Loader/Loader';
import * as action from '../../Pages/Library/ColorLibary/store/ColorLibrary.action';
import CustomTooltip from '../Tooltip/CustomTooltip';

const uploadingPdforImage = (others, getInputProps, isDragActive) => {
  return others(getInputProps, isDragActive);
};

function UploadFileAndDocuments({ acceptedFileExtenstion, showTitleField, showLoader, clearChild, onOpen, toggle }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const [error, setError] = useState({
    fileName: '',
    document: '',
    sizeError: '',
    invalidextExtension: '',
    error: '',
  });
  const [files, setFiles] = useState([]);
  const [supportingDocuments, setSupportingDocuments] = useState({
    fileName: '',
    document: '',
  });

  const [disable, setDisable] = useState(false);
  const objectAssignment = (file) => {
    return Object.assign(file, {
      preview: URL.createObjectURL(file),
    });
  };

  useEffect(() => {
    if (clearChild) {
      setFiles([]);
      setSupportingDocuments({ fileName: '', document: '' });
    }
  }, [clearChild]);

  const onFileDrop = (acceptedFiles, fileRejections) => {
    if (fileRejections.length) {
      setError((err) => ({
        ...err,
        error: t('UPLOAD_FILE_AND_DOCUMENTS.ERROR_FILE_INVALID'),
      }));
    } else if (!isEmpty(acceptedFiles) && isEmpty(fileRejections)) {
      setError((errs) => ({ ...errs, error: '' }));
      const fileSize = (acceptedFiles[0].size / 1024 / 1024).toFixed(0);
      if (fileSize > 20) {
        setError((oldErr) => ({
          ...oldErr,
          error: t('UPLOAD_FILE_AND_DOCUMENTS.ERROR_FILE_SIZE_EXCEED'),
        }));
        setFiles([]);
        setSupportingDocuments((doc) => ({
          ...doc,
          document: '',
        }));
      } else {
        setError((prevErr) => ({
          ...prevErr,
          error: '',
          document: '',
          sizeError: '',
        }));
        setSupportingDocuments((doc) => ({
          ...doc,
          fileName: acceptedFiles[0].name.split('.').slice(0, -1).join('.'),
          document: acceptedFiles[0],
        }));
        setFiles(acceptedFiles.map((file) => objectAssignment(file)));
      }
    }
  };

  useEffect(
    () => () => {
      files.forEach((file) => {
        URL.revokeObjectURL(file.preview);
      });
    },
    [files],
  );

  const filesName = files.map((file) => {
    return <span key={file.path}>{file.path}</span>;
  });

  const validateForm = () => {
    let formIsValid = true;
    const errors = { fileName: '', document: '', error: '' };

    if (showTitleField) {
      if (isEmpty(supportingDocuments.fileName.replace(/\s/g, ''))) {
        formIsValid = false;
        errors.fileName = t('UPLOAD_FILE_AND_DOCUMENTS.ERROR_DOCUMENT_TITLE_REQUIRED');
      }
    }
    if (!supportingDocuments.document) {
      formIsValid = false;
      errors.error = t('UPLOAD_FILE_AND_DOCUMENTS.ERROR_FILE_REQUIRED');
    }
    setError((state) => ({
      ...state,
      ...errors,
    }));
    return formIsValid;
  };

  const handleChange = (event) => {
    const fieldName = event.currentTarget.name;
    setSupportingDocuments({
      ...supportingDocuments,
      [fieldName]: event.currentTarget.value,
    });
  };

  const others = (getInputProps, isDragActive) => {
    return (
      <div>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p className="mb-0">{t('UPLOAD_FILE_AND_DOCUMENTS.DROP_FILE_HERE')}</p>
        ) : (
          <p className="mb-0 text-center">{t('UPLOAD_FILE_AND_DOCUMENTS.DRAG_AND_DROP_FILE_HERE')}</p>
        )}
        <p className="text-center mb-0">{filesName}</p>
      </div>
    );
  };

  const formatFileSize = (bytes, decimalPoint) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1000;
    const dm = decimalPoint || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisable(true);
    if (validateForm()) {
      if (supportingDocuments?.document && !isEmpty(supportingDocuments?.document)) {
        if (isEmpty(error.fileName) && isEmpty(error.error)) {
          const formData = new FormData();
          const uploadedDoc = supportingDocuments;
          if (uploadedDoc) {
            const { document } = uploadedDoc;
            formData.append('file', document);
            formData.append('size', formatFileSize(document?.size, 2));
            formData.append('fileName', supportingDocuments.fileName);
          }
          await dispatch(action.addColourSupportingDocs(formData, t));
          toggle();
        }
      }
    }
    setDisable(false);
  };

  return (
    <Modal show={onOpen} onHide={toggle} className="common-custom-modal modal-large" aria-labelledby="upload-file-modal-title" backdrop="static">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title className="f-24" id="upload-file-modal-title">
            {t('UPLOAD_FILE_AND_DOCUMENTS.MODAL_TITLE')}
          </Modal.Title>
          <span onClick={() => toggle()} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Loader />
        ) : (
          <form noValidate>
            <div className="bom-image-upload ">
              <Dropzone accept={acceptedFileExtenstion} onDrop={onFileDrop}>
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <section className="upload-image-section p-3" {...getRootProps()}>
                    {uploadingPdforImage(others, getInputProps, isDragActive)}

                    <label className="upload-icon ">
                      <input {...getInputProps()} type="file" className="img-Upload" />
                      <a href={() => false} className="align-items-center justify-content-center">
                        <span className="icon-upload" />
                      </a>
                    </label>
                  </section>
                )}
              </Dropzone>

              {!isEmpty(Object.keys(error)) && (
                <div className="d-flex align-items-center justify-content-center">
                  <span className="error-message text-center w-50">{error.error}</span>
                </div>
              )}

              {showTitleField && (
                <div className="d-flex w-100">
                  <div className="w-100">
                    <input
                      type="text"
                      name="fileName"
                      value={supportingDocuments?.fileName}
                      onChange={handleChange}
                      className="input-doc-type form-control"
                      placeholder={t('UPLOAD_FILE_AND_DOCUMENTS.DOCUMENT_TITLE_PLACEHOLDER')}
                    />
                    {error?.fileName && <span className="error-message">{error?.fileName}</span>}
                  </div>
                </div>
              )}
            </div>
            <div className="common-model-footer mt-16 d-flex justify-content-end">
              <CustomTooltip tooltipText={t('UPLOAD_FILE_AND_DOCUMENTS.BUTTON_ADD')}>
                <button disabled={disable} type="button" className={`btn p-0 ${disable ? 'loading' : ''}`} onClick={(e) => handleSubmit(e)}>
                  {disable ? <i className="fa fa-spinner fa-spin" /> : <i className="icon-Tick-1 f-24" />}
                </button>
              </CustomTooltip>
            </div>
          </form>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default UploadFileAndDocuments;
